import { LogoIcon } from '@higo/ui';
import styled, { css } from 'styled-components';
import React, { FC, ReactNode } from 'react';

const Container = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2.5rem;
  `,
);

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  min-width: 14.5625rem;
  max-width: 25rem;
  width: 100%;
  margin: 0 auto;
`;
export interface FullPageMessageProps {
  icon?: ReactNode;
}

export const FullPageMessage: FC<FullPageMessageProps> = ({
  icon = <LogoIcon size={32} />,
  children,
}) => (
  <Container>
    <Content>
      <div>{icon}</div>
      <div>{children}</div>
    </Content>
  </Container>
);
